@use '~@frontrow/console/css/variables.scss';

@forward '~@frontrow/console/css/variables.scss';

.button {
  margin-bottom: variables.$std-margin-md;
}
